import { render, staticRenderFns } from "./StaffExportYearlyAttendancePage.vue?vue&type=template&id=0b653e76&scoped=true&"
import script from "./StaffExportYearlyAttendancePage.vue?vue&type=script&lang=js&"
export * from "./StaffExportYearlyAttendancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b653e76",
  null
  
)

export default component.exports